import {
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import { SaleItems } from "../../../models/settlement.model";

const columns = [
  { id: 0, title: "ردیف" },
  {
    id: 1,
    title: "گروه کالا",
  },
  {
    id: 2,
    title: "عنوان کالا",
  },
  {
    id: 3,
    title: "مقدار",
  },
  {
    id: 4,
    title: " مجموع فروش (ریال)",
  },
  {
    id: 5,
    title: "مبلغ تسویه(ريال)",
  },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

interface Props {
  saleItems: SaleItems[];
}

const FactorTabTable = ({ saleItems }: Props) => {
  return (
    <div>
      <TableContainer component={Paper} sx={{ maxHeight: "80vh" }}>
        <Table
          stickyHeader
          sx={{
            minWidth: { xs: 0, sm: 0, md: 700, lg: 900 },
          }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              {columns.length > 0 &&
                columns.map((column) => (
                  <StyledTableCell align="center">
                    {column.title}
                  </StyledTableCell>
                ))}
            </TableRow>
          </TableHead>

          <TableBody
            sx={{
              outline: "1px solid #DAE0E4",
            }}
          >
            {saleItems?.map((item: SaleItems, index) => (
              <StyledTableRow sx={{ cursor: "pointer" }} onClick={() => {}}>
                <StyledTableCell align="center" component="th" scope="row">
                  <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                    {index + 1}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" component="th" scope="row">
                  <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                    {item?.saleItemGroupTitle}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" component="th" scope="row">
                  <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                    {item?.title}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" component="th" scope="row">
                  <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                    {item?.quantity?.toLocaleString("fa")}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" component="th" scope="row">
                  <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                    {item?.saleItemTotalAmount?.toLocaleString("fa")}
                  </p>
                </StyledTableCell>
                <StyledTableCell align="center" component="th" scope="row">
                  <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                    {item?.settlementTotalAmount?.toLocaleString("fa")}
                  </p>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default FactorTabTable;
